module.exports = __webpack_public_path__ + "img/avatar-s-23.6128b34a.jpg";